<template lang="html">
  <div class="jobs">
     <bannerTop :banners="$t('jobs.banners')"/>
     <div class="weOffer">
       <div class="job" v-for="(item,key) in $t('jobs.offer')" :key="key">
         <img :src="item.icon" alt="">
         <span class="info">
           <p class="title">{{titleToUpperCase(item.title)}}</p>
           <p class="description" v-html="item.description"></p>
         </span>
       </div>
     </div>
     <ul class="jobsList">
       <li v-for="(job,key) in jobList" :key="key">
         <p class="title">
           {{job.title}}
           <span class="address"><img src="../assets/images/jobs/job-location-icon.png" alt="">{{job.address}}</span>
         </p>
         <p class="description" v-html="job.description"></p>
         <span class="imBtn" onclick="showChatBOx()">
           <img src="../assets/images/jobs/job-talk-icon.png" alt="">
           <!-- {{$t('jobs.applyNow')}} -->
         </span>
         <span class="wapChat" @click="toWapChat()">
           <img src="../assets/images/jobs/job-talk-icon.png" alt="">
           <!-- {{$t('jobs.applyNow')}} -->
         </span>
       </li>
     </ul>
     <div class="pages">
       <span v-for="(page,key) in pages" @click="changePage(key,page)" :class="currentPage ==page? 'active' : ''" :key="key">{{page}}</span>
     </div>
  </div>
</template>

<script>
import bannerTop from '@/components/bannerTop'
export default {
  name: 'jobs',
  data(){
    return{
      jobList: [],
      pageSize: 10,
      pages: 0,
      currentPage: 0
    }
  },
  components:{
    bannerTop
  },
  created(){
    let self = this
    self.jobList = self.$t('jobs.jobs')
    self.pages = Math.ceil(self.jobList.length / self.pageSize)
    // console.log(self.pages, '////');
    self.changePage(0,1)
  },
  methods:{
    changePage(key,page){
      let self = this
      let showJobs = []
      let jobsData = self.$t('jobs.jobs')
      // console.log(key,page, '////');
      if( page != self.currentPage){
        showJobs = jobsData.slice(key*self.pageSize, page*self.pageSize <= jobsData.length ? page*self.pageSize : jobsData.length )
      }
      self.jobList = showJobs
      self.currentPage = page
    },
    showChatBox(){
      // console.log();
    }
  }
}
</script>

<style lang="less" src="../assets/css/jobs.less"></style>
